import client from '../sanityClient';

export async function getItemById(itemId) {
  const query = '*[_type == "item" && _id == $id][0]';
  return await client.fetch(query, { id: itemId });
} 